import ReactDOM from 'react-dom';
// -*- mode: jsx;-*-
import Directory from './Directory.js';


$(() => {
    const isMobile = typeof isMobileView === 'function' && isMobileView();
    ReactDOM.render(
        <Directory
            districtData={districtData}
            stateNames={states}
            isMobile={isMobile}
        />,
        document.getElementById('content')
    );
});
